import React, { Component } from 'react'
import cn from 'classnames'
import { Collapse, IconButton } from '@material-ui/core'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { ReactComponent as ImageIcon } from 'assets/img/image-icon.svg'
import ImageModal from 'components/common/Modals/ImageModal'
import { ReactComponent as CloseIcon } from 'assets/img/close-icon.svg'
import { ReactComponent as VideoIcon } from 'assets/img/video-icon.svg'
import parse from 'html-react-parser'
import Loading from 'components/Loading'
import TextEditor from 'components/common/TextEditor'
import {
  TYPE_INPUT_TEXT,
  TYPE_INPUT_NUMBER,
  TYPE_INPUT_BOOLEAN,
  TYPE_INPUT_DATE,
  TYPE_INPUT_TIME,
  TYPE_INPUT_FILE,
  TYPE_INPUT_MULTIPLE_FILES,
  TYPE_SELECT,
  TYPE_INPUT_CALCULATED,
  TYPE_INPUT_COUNTER,
  TYPE_INPUT_DATE_TIME,
  TYPE_INPUT_SIGNATURE,
} from 'helpers/jobs'
import { embedableYoutubeVideo } from 'helpers/youtubeVideo'
import { getDemoDataResult } from 'helpers/demo-data'
// import FadeInImage from 'components/common/FadeInImage'
import ReactImageAppear from 'react-image-appear'
import { canRenderConditionalInputOrGroup } from '../Common/utils'
import { CONDITIONAL_ITEM_TYPE } from '../Common/Common.types'
import TextInput from './JobTextInput'
import NumberInput from './JobNumberInput'
import BooleanInput from './JobBooleanInput'
import DateInput from './JobDateInput'
import DateTimeInput from './JobDateTimeInput'
import TimeInput from './JobTimeInput'
import FileInput from './JobFileInput'
import MultipleFilesInput from './JobMultipleFilesInput'
import SelectInput from './JobSelectInput'
import JobSignatureInput from './JobSignatureInput/JobSignatureInput'
import messages from '../translate'

class JobField extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showImageBlock: false,
      showVideoBlock: false,
      isVideoIframeLoading: false,
      isModalOpen: false,
    }
  }

  onValueChange = data => {
    const { onFieldValueChange } = this.props

    if (typeof onFieldValueChange === 'function') {
      onFieldValueChange(data)
    }
  }

  getInputProps = () => {
    const { inputInfo } = this.props
    const { type, options, parameters } = inputInfo
    const props = {
      ...this.props,
      onFieldValueChange: this.onValueChange,
    }

    if (type === TYPE_SELECT) {
      props.options = options || parameters.options
    }

    return props
  }

  handleChangeImageBlock = () => {
    this.setState(prevState => ({ showImageBlock: !prevState.showImageBlock }))
  }

  handleShowVideo = () => {
    this.setState(prevState => ({
      showVideoBlock: !prevState.showVideoBlock,
      isVideoIframeLoading: false,
    }))
  }

  handleModalChange = () => {
    this.setState(prevState => ({ isModalOpen: !prevState.isModalOpen }))
  }

  handleChangeLoader = () => {
    this.setState({ isVideoIframeLoading: false })
  }

  render() {
    const {
      inputInfo: {
        type,
        instructions,
        video,
        image,
        workflow_input,
        parameters,
        availability,
        id,
      },
      inputData: { value },
      intl: { formatMessage, locale },
      featureFlags,
      dependency: {
        currentEvtTask: { evt_inputs, id: evtTaskId },
      },
    } = this.props
    const {
      showImageBlock,
      isModalOpen,
      showVideoBlock,
      isVideoIframeLoading,
    } = this.state
    const inputList = {
      [TYPE_INPUT_TEXT]: TextInput,
      [TYPE_INPUT_NUMBER]: NumberInput,
      [TYPE_INPUT_CALCULATED]: NumberInput,
      [TYPE_INPUT_COUNTER]: NumberInput,
      [TYPE_INPUT_BOOLEAN]: BooleanInput,
      [TYPE_INPUT_DATE]: DateInput,
      [TYPE_INPUT_TIME]: TimeInput,
      [TYPE_INPUT_FILE]: FileInput,
      [TYPE_INPUT_MULTIPLE_FILES]: MultipleFilesInput,
      [TYPE_SELECT]: SelectInput,
      [TYPE_INPUT_DATE_TIME]: DateTimeInput,
      [TYPE_INPUT_SIGNATURE]: JobSignatureInput,
    }
    const Input = inputList[type]

    if (!Input) {
      return null
    }

    // TODO only for demo, delete if after demo
    const customInstructions = getDemoDataResult(value, workflow_input, locale)
    // TODO remove this

    const imageTitle = showImageBlock ? messages.hideImage : messages.showImage
    const videoTitle = showVideoBlock ? messages.hideVideo : messages.showVideo
    const embededVideo = embedableYoutubeVideo(video)

    if (
      canRenderConditionalInputOrGroup(
        evt_inputs,
        parameters,
        availability,
        evtTaskId,
        id,
        CONDITIONAL_ITEM_TYPE.INPUTS,
      ) &&
      featureFlags.CONDITIONAL_INPUTS
    ) {
      return null
    }

    return (
      <>
        {(instructions || image || embededVideo) && (
          <div className="job-task-notification">
            <span className="job-task-notification-icon">i</span>
            {instructions && (
              <div
                className={cn('job-task-notification-title', {
                  noPreLine: featureFlags.INSTRUCTIONS_TEXT_EDITOR,
                })}>
                {featureFlags.INSTRUCTIONS_TEXT_EDITOR ? (
                  <TextEditor
                    input={{ value: instructions }}
                    showToolbar={false}
                    readOnly
                  />
                ) : (
                  instructions
                )}
              </div>
            )}
            {image && (
              <div
                className={cn('wrap', {
                  showBlock: showImageBlock,
                })}>
                <ImageIcon />
                <div className="title" onClick={this.handleChangeImageBlock}>
                  {formatMessage(imageTitle)}
                </div>
                <Collapse in={showImageBlock}>
                  <img // eslint-disable-line jsx-a11y/no-noninteractive-element-interactions
                    className="image"
                    src={image}
                    onClick={this.handleModalChange}
                    alt=""
                  />
                  <ImageModal
                    open={isModalOpen}
                    onClose={this.handleModalChange}>
                    <div className="modal-content">
                      <div className="image-wrap-content">
                        {/* TODO work with it */}
                        {/* <FadeInImage */}
                        {/*  src={image} */}
                        {/*  placeholderStyle={{ */}
                        {/*    backgroundColor: 'transparent', */}
                        {/*  }} */}
                        {/* /> */}
                        <ReactImageAppear
                          src={image}
                          animationDuration="2s"
                          placeholderStyle={{
                            backgroundColor: 'transparent',
                          }}
                        />
                      </div>
                      <div className="btn-wrap">
                        <IconButton onClick={this.handleModalChange}>
                          <CloseIcon />
                        </IconButton>
                      </div>
                    </div>
                  </ImageModal>
                </Collapse>
              </div>
            )}
            {embededVideo && (
              <div className={cn('wrap', { showBlock: showVideoBlock })}>
                <VideoIcon />
                <div className="title" onClick={this.handleShowVideo}>
                  {formatMessage(videoTitle)}
                </div>
                <Collapse in={showVideoBlock}>
                  <div className="iframe-wrapper">
                    {isVideoIframeLoading && <Loading pastDelay />}
                    <iframe
                      src={embededVideo}
                      frameBorder="0"
                      allow="autoplay; encrypted-media"
                      title="video"
                      allowFullScreen="1"
                      onLoad={this.handleChangeLoader}
                    />
                  </div>
                </Collapse>
              </div>
            )}
          </div>
        )}
        <Input {...this.getInputProps()} />
        {/* TODO remove this after demo */}
        {customInstructions !== null && (
          <div className="job-task-notification">
            <span className="job-task-notification-icon">i</span>
            <div className="job-task-notification-title">
              {parse(customInstructions)}
            </div>
          </div>
        )}
        {/* TODO end */}
      </>
    )
  }
}

export default connect(state => ({
  featureFlags: state.getIn(['profile', 'profile', 'featureFlags']),
}))(injectIntl(JobField))
